import React, { useEffect } from "react";
import svg8 from "../../../../assets/svg/svg8.svg";
import svg9 from "../../../../assets/svg/svg9.svg";
import svg40 from "../../../../assets/svg/svg40.svg";
import { Divider } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData, fetchFiles } from "../../../../features/fetch/fetchSlice";
import DocumentAdd from "./DocumentAdd";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import {  formatPathDoc } from "../../../../utils";

const items = [
  {
    title: "Contract.pdf",
  },
  {
    title: "Pipe system.png",
  },
  {
    title: "Southern view.png",
  },
];
function Documents() {
  const { open, handleCancel, handleOpen } = useModalToggle();

  const url = "api/v2/projectFiles/get";
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { activeObjexpressions, data } = useSelector((state) => ({
    activeObjexpressions: state.obj.activeObj["expressions"],
    data: state.fetch.data[url] || [],
  }));

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFiles({ file: item?.pfFilePath }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  async function fetchDocsData() {
    await dispatch(
      fetchData({
        url: url,
        pfProjectId: activeObjexpressions?.projectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchDocsData();
  }, []);

  return (
    <>
      <div className="white_card   flex-1">
        <div className="flex  justify-between  flex-shrnk flex-wrap  items-center lg:gap-[1.75rem] gap-[.2rem]">
          <div className="badge">Documents</div>
          <div
            onClick={handleOpen}
            className="flex justify-center items-center border border-darkBlue h-[30px] w-[30px] cursor-pointer"
          >
            <img src={svg40} alt="svg40" />
          </div>
        </div>

        <div className="mt-[2rem]">
          {data &&
            data?.map((item) => (
              <>
                <div className="cursor-pointer flex items-center justify-between">
                  <div className="flex items-center gap-x-[.5rem]">
                    <img src={svg8} alt="svg8" />
                    <span
                      onClick={() => downloadFile(item)}
                      className="text-[#706F6F] font-interSans font-[400] text-[.95rem]"
                    >
                      <span
                        onClick={() => downloadFile(item)}
                        title={formatPathDoc(item?.pfFileName)}
                        className="text-[#706F6F] font-interSans font-[400] text-[.95rem] cursor-pointer"
                      >
                        {formatPathDoc(item?.pfFileName)?.length > 10
                          ? formatPathDoc(item?.pfFileName).slice(0, 10) + "..."
                          : formatPathDoc(item?.pfFileName)}
                      </span>
                    </span>
                  </div>

                  <div
                    onClick={() => downloadFile(item)}
                    className="flex items-center gap-x-[.5rem]"
                  >
                    <img src={svg9} alt="svg9" />
                  </div>
                </div>
                <div className="my-[1.38rem] ">
                  <Divider />
                </div>
              </>
            ))}
        </div>
      </div>

      <DocumentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchDocsData}
      />
    </>
  );
}

export default Documents;
